import { styled } from '@clickcease/cc-client-components-lib'

export const ConnectionModalContainer = styled('div', {
  borderRadius: '4px',
  width: '930px',
})

export const CampaignsModalContainer = styled('div', {
  borderRadius: '4px',
})

export const ModalContentContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
})

export const Heading = styled('h2', {
  all: 'unset',
  fontWeight: '$sb',
  fontSize: '$h3',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: '$textColor',
})

export const Text = styled('p', {
  all: 'unset',
  fontWeight: '$sl',
  fontSize: '$md',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})

export const Link = styled('a', {
  marginLeft: '5px',
  fontWeight: 400,
  fontSize: '$lg',
  lineHeight: 1.2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',

  '&:hover': {
    color: 'rgb(160, 159, 165)',
    cursor: 'pointer',
  },
})

export const ColumnBlock = styled('div', {
  marginTop: '$4',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const Expalinertext = styled('span', {
  fontSize: '$md',
  fontWeight: '$l',
  color: '$disabled',
})
